import React from 'react';
import { Typography } from '@material-ui/core';
import { OptionTypeBase } from 'react-select';
import { OptionProps } from 'react-select/src/components/Option';

import { useTranslation } from 'hooks/useTranslation';

export const NoOptionsMessage = (props: OptionProps<OptionTypeBase, boolean>) => {
  const { t } = useTranslation();

  return (
    <Typography color="textSecondary" className={props.selectProps.classes.noOptionsMessage} {...props.innerProps}>
      {t('noOptions')}
    </Typography>
  );
};
